import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  CardIssuePoint,
  CardIssuePointFilter,
  CardIssuePointOrderFields,
  CardIssuePointsService,
  MunicipalEntitiesService,
  MunicipalEntity,
  OrderDirection,
  cardIssuePointGetAddress,
} from '@prodcard/core'
import { ref, watch } from 'vue'
import VAutocompleteServer from './VAutocompleteServer.vue'
import { createCtx, handleError } from '../helpers'
import { isEqual, uniq } from 'lodash'

interface CardIssuePointForSelect {
  address: string
  id: string
}

interface Props {
  cardIssuePointsService: CardIssuePointsService
  municipalEntitiesService: MunicipalEntitiesService
  additionalFilterData?: CardIssuePointFilter
  modelValue?: string
  label?: string
  loading?: boolean
  disabled?: boolean
  readonly?: boolean
}

const count = 15


export default /*#__PURE__*/_defineComponent({
  __name: 'VCardIssuePointSelect',
  props: {
    cardIssuePointsService: {},
    municipalEntitiesService: {},
    additionalFilterData: {},
    modelValue: {},
    label: { default: 'Пункт выдачи карт' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



const cardIssuePoints = ref<CardIssuePointForSelect[]>([])

const select = ref()
const loadDefaultCardIssuePoint = ref(false)
const isLoadMoreItems = ref(true)
const from = ref(0)
const total = ref(0)
const aggregateCardIssuePoint = (
  cardIssuePoint: CardIssuePoint,
  municipalEntities: MunicipalEntity[],
): CardIssuePointForSelect => {
  const comment = cardIssuePoint.comment
  const index = municipalEntities.find(me => me.id === cardIssuePoint.municipalEntityId)?.index
  return {
    address:
      `${index}.${cardIssuePoint.number} ${cardIssuePointGetAddress(cardIssuePoint)}` +
      (!!comment ? ` (${comment})` : ''),
    id: cardIssuePoint.id,
  }
}

const updateCardIssuePointList = (
  paging: { from: number; count: number },
  filter?: CardIssuePointFilter,
  replace = false,
) => {
  handleError(async () => {
    const ctx = createCtx()
    const response = await props.cardIssuePointsService.findAll(ctx, {
      paging,
      filter,
      order: { field: CardIssuePointOrderFields.NUMBER, direction: OrderDirection.ASC },
    })

    const meIds = uniq(response.items.map(cip => cip.municipalEntityId))
    const municipalEntities = await props.municipalEntitiesService.findAll(ctx, { filter: { ids: meIds }, paging: {} })

    const resultList = response.items.map(cip => aggregateCardIssuePoint(cip, municipalEntities.items))

    if (replace) {
      cardIssuePoints.value = resultList
    } else {
      cardIssuePoints.value.push(...resultList)
    }

    isLoadMoreItems.value = cardIssuePoints.value.length < response.total
    from.value += paging.count
    if (total.value !== response.total) total.value = response.total
  })
}

const updateSearchValue = (val: string) => {
  from.value = 0
  updateCardIssuePointList({ from: from.value, count: count }, { ...props.additionalFilterData, search: val }, true)
}

const findDefaultCardIssuePointById = (id: string) => {
  handleError(async () => {
    const ctx = createCtx()
    const cardIssuePoint = await props.cardIssuePointsService.findById(ctx, id)
    if (!cardIssuePoint) return

    const municipalEntities = await props.municipalEntitiesService.findAll(ctx, {
      filter: { ids: [cardIssuePoint.municipalEntityId] },
      paging: {},
    })

    select.value = aggregateCardIssuePoint(cardIssuePoint, municipalEntities.items)
  }, loadDefaultCardIssuePoint)
}

watch(
  () => props.modelValue,
  val => {
    if (!val && select.value) {
      select.value = undefined
      from.value = 0
      updateCardIssuePointList({ from: from.value, count: count }, props.additionalFilterData, true)
      return
    }
    if (select.value || !val) return

    findDefaultCardIssuePointById(val)
  },
  { immediate: true },
)

watch(
  () => props.additionalFilterData,
  (newVal, oldVal) => {
    if (!isEqual(newVal, oldVal)) {
      from.value = 0
      updateCardIssuePointList({ from: from.value, count: count }, newVal, true)
    }
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VAutocompleteServer, {
    modelValue: select.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((select).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:model-value', $event?.id)))
    ],
    items: cardIssuePoints.value,
    isLoadMoreItems: isLoadMoreItems.value,
    label: _ctx.label,
    "item-title": "address",
    loading: loadDefaultCardIssuePoint.value || _ctx.loading,
    disabled: loadDefaultCardIssuePoint.value || _ctx.disabled,
    readonly: _ctx.readonly,
    "onUpdate:searchValue": updateSearchValue,
    onLoadMore: _cache[2] || (_cache[2] = search => updateCardIssuePointList({ from: from.value, count: count }, { search, ..._ctx.additionalFilterData }))
  }, null, 8, ["modelValue", "items", "isLoadMoreItems", "label", "loading", "disabled", "readonly"]))
}
}

})